import type { SearchStatus } from '../enums/SearchStatus'
import type { SearchType } from '../enums/SearchType'
import type { DeliveryBoundaryEntity } from './DeliveryBoundaryEntity'

export class SearchDeliveryEntity {
  id?: string
  deliveryId?: string
  status?: SearchStatus
  type?: SearchType
  rounds?: Array<DeliveryBoundaryEntity>
  numberOfEmptyRounds?: number
}
